import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useResendInvite = () => {
  const { mutateAsync, isLoading, isSuccess, isError, error } = useMutation({
    mutationFn: (userId: string) => api.post(`users/${userId}/resend-invite`),
  });

  const resendInvite = async (userId: string) => {
    await mutateAsync(userId);
  };

  return {
    resendInvite,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
